import React, {useCallback, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {currencyFormat} from "../../../utils/masks";
import {getReport} from "../../../services/Trading";
import {useTranslation} from "react-i18next";
import {FaSmile, FaFrown, FaEquals} from "react-icons/fa";
import {
    InsightStack,
    InsightRow,
    InsightIconBox,
    InsightText,
    InsightTitle,
    InsightDesc,
    InsightValue,
    InsightBadge,
    getAccent,
} from "../TradingInsightCard/styles";

export default function CardProfitPrejudice({filter}) {
    const {coinType, initialValue} = useSelector((state) => state.BankReducer);
    const [profitPrejudice, setProfitPrejudice] = useState(null);
    const [percentTotalValue, setPercentTotalValue] = useState(null);

    const { t } = useTranslation();

    const updateData = useCallback(() => {
        getReport({
            startDate: filter[0].startDate,
            endDate: filter[0].endDate,
            orderBy: 'profitObtained',
            order: 'DESC'
        }).then((data) => {
            if (!data || data === '' || !data.data) {
                return;
            }

            const valueWin = parseFloat(data.data.win.totalValue ? data.data.win.totalValue : 0);
            const valueLoss = parseFloat(data.data.loss.totalValue ? data.data.loss.totalValue : 0);

            setProfitPrejudice(valueWin + valueLoss);
            let value = valueWin + valueLoss;
            value = (value && initialValue) ? value * 100 / initialValue : 0;
            setPercentTotalValue(value.toFixed(2));
        });
    }, [initialValue, filter]);

    useEffect(() => {
        updateData();
    }, [updateData]);

    const variant =
        profitPrejudice == null
            ? 'resumeNeutral'
            : profitPrejudice > 0
              ? 'resumeProfit'
              : profitPrejudice < 0
                ? 'resumeLoss'
                : 'resumeNeutral';

    const a = getAccent(variant);
    const IconSecond =
        profitPrejudice == null
            ? FaEquals
            : profitPrejudice > 0
              ? FaSmile
              : profitPrejudice < 0
                ? FaFrown
                : FaEquals;

    const resumeTitle =
        profitPrejudice == null
            ? t('traging_report_card_resume_profit_prejudice')
            : profitPrejudice > 0
              ? t('traging_report_card_resume_profit')
              : profitPrejudice < 0
                ? t('traging_report_card_resume_prejudice')
                : t('traging_report_card_resume_profit_prejudice');

    return (
        <InsightStack>
            <InsightRow $variant={variant}>
                <InsightIconBox $variant={variant}>
                    <IconSecond aria-hidden/>
                </InsightIconBox>
                <InsightText>
                    <InsightTitle>{resumeTitle}</InsightTitle>
                    <InsightDesc>{t('trading_report_desc_resume_value')}</InsightDesc>
                </InsightText>
                <InsightValue
                    $color={a.value}
                    style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6}}
                >
                    <span>
                        {coinType}{' '}
                        {profitPrejudice != null ? currencyFormat(profitPrejudice) : '—'}
                    </span>
                    <span style={{fontSize: 13, fontWeight: 700, color: 'rgba(180,195,230,0.85)'}}>
                        {t('banking_growth')}
                    </span>
                    <InsightBadge $variant={variant} style={{marginLeft: 0}}>
                        {profitPrejudice != null && profitPrejudice > 0 ? '+' : ''}
                        {percentTotalValue != null ? `${percentTotalValue}%` : '—'}
                    </InsightBadge>
                </InsightValue>
            </InsightRow>
        </InsightStack>
    );
}
